import {Animations, AnimationType} from "./Animations";
import {Animation} from "../../feature/project/Shot";
import React from "react";
import {Button, Flex, Modal} from "antd";

export const SelectAnimationModal = (props: { onCancel: () => void, onSelect: (animation: Animation, type: AnimationType) => void, type: AnimationType }) => {

    return (
        <Modal
            open={true}
            closeIcon={null}
            title={<Flex justify={'space-between'}>Select {props.type == AnimationType.Animation ? 'Animation' : 'Transition'}<Button type={'primary'} >New {props.type == AnimationType.Animation ? 'Animation' : 'Transition'}</Button></Flex>}
            width={1000}
            footer={<Button type={'default'} onClick={props.onCancel}>Close</Button>}
            onCancel={props.onCancel}
        >
            <Animations onSelect={(animation: Animation, type: AnimationType) => {
                props.onSelect(animation, type)
                props.onCancel()
            }} type={props.type}/>
        </Modal>
    )
}